import { LoadState } from "../../constants/enums";
import { IRoomState, IRoom } from "./room.types";

export const initialRoomState: IRoomState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};

export const initialRoom: IRoom = {
  room_uuid: null,
  room_name: "",
  room_price: 0,
  company_outlet_uuid: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: null,
  insert_ts: "",
};
